var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link font-weight-bold text-white",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.abrirSolicitudSoporte.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-headset mr-1"}),_vm._v("Solicitud soporte ")])
}
var staticRenderFns = []

export { render, staticRenderFns }